import React, { Fragment, useRef, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import UserImage07 from '../images/kieran.jpg';
import TopCategoriesCard from "./dashboard/trending-content/TopCategoriesCard";

function CTAModal(props) {

  const [open, setOpen] = useState(false)
  const cancelButtonRef = useRef(null)
  const [topCTA, setTopCTA] = useState([])

  useEffect(() => {

    if(props.params)
      setOpen(true)
    else
      setOpen(false)

    if(props.params && props.params.item){
        var ctas = [{category: 'purchase', campaigns: props.params.item.purchase, fill: (props.params.item.purchase*100).toFixed(0).toString()+'%'},
            {category: 'awareness', campaigns: props.params.item.awareness, fill: (props.params.item.awareness*100).toFixed(0).toString()+'%'},
            {category: 'claim', campaigns: props.params.item.claim, fill: (props.params.item.claim*100).toFixed(0).toString()+'%'},
            {category: 'discover', campaigns: props.params.item.discover, fill: (props.params.item.discover*100).toFixed(0).toString()+'%'},
            {category: 'reminder', campaigns: props.params.item.reminder, fill: (props.params.item.reminder*100).toFixed(0).toString()+'%'},
            {category: 'account', campaigns: props.params.item.account, fill: (props.params.item.account*100).toFixed(0).toString()+'%'},
            {category: 'play', campaigns: props.params.item.play, fill: (props.params.item.play*100).toFixed(0).toString()+'%'},
            {category: 'social', campaigns: props.params.item.social, fill: (props.params.item.social*100).toFixed(0).toString()+'%'},
            {category: 'watch', campaigns: props.params.item.watch, fill: (props.params.item.watch*100).toFixed(0).toString()+'%'},
            {category: 'feedback', campaigns: props.params.item.feedback, fill: (props.params.item.feedback*100).toFixed(0).toString()+'%'},
            {category: 'download', campaigns: props.params.item.download, fill: (props.params.item.download*100).toFixed(0).toString()+'%'}]
        ctas.sort((a, b) => {
            return b.campaigns - a.campaigns;
        });
      setTopCTA(ctas)

    }
  }, [props]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        open={open}
        onClose={setOpen}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-1 transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="flex w-full">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12
                  rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
                    {props!==null && props.params!==null?<img className="rounded-full"
                                                              src={props.params.icon} width="32" height="32" alt=''/>:''}
                  </div>
                  <div className="mt-3 flex-grow text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      {props!==null && props.params!==null?props.params.item.brand:''} | {props!==null && props.params!==null?props.params.item.market:''}
                    </Dialog.Title>
                    <div className="mt-2">
                      <table className="table-auto w-full mb-2">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                        <tr>
                          <th className="p-3">
                            <div className="font-semibold text-center">Message</div>
                          </th>
                        </tr>
                        </thead>
                        {/* Table body */}
                        {props!==null && props.params!==null?<tbody className="text-sm font-medium divide-y divide-gray-100">
                        <tr className="cursor-pointer" key={props.params.item.id} role="row">
                          <td className="p-2">
                            <div className="flex items-center">
                              <div className="text-gray-800 line-clamp-3">{props.params.item.text}</div>
                            </div>
                          </td>
                        </tr>
                        </tbody>:''}

                      </table>
                      {topCTA.length>0?
                        <TopCategoriesCard title="Predicted Call-to-action" category="CTA Category" data={topCTA} palette={2}
                                           hint={"Probabilities of campaign content belonging to CTA categories."}/>:''}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md focus:outline-none border border-gray-300
                   shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0
                   sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => {
                      setOpen(false)
                      props.toggleState(null)
                    }
                  }
                  ref={cancelButtonRef}>
                  Okay
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default CTAModal